import { useEffect, useRef } from 'react';
import { toast } from 'sonner';

const SIX_HOURS = 6 * 60 * 60 * 1000;

export function useVersionCheck() {
  const currentVersion = useRef(null);
  const hasPrompted = useRef(false);

  useEffect(() => {
    const check = async () => {
      if (hasPrompted.current) return;
      try {
        const res = await fetch(`/version.json?t=${Date.now()}`);
        if (!res.ok) return;
        const { version } = await res.json();

        if (currentVersion.current === null) {
          currentVersion.current = version;
          return;
        }

        if (version !== currentVersion.current) {
          hasPrompted.current = true;
          toast('A new version is available', {
            description: 'Refresh to get the latest update.',
            duration: Infinity,
            action: {
              label: 'Refresh',
              onClick: () => window.location.reload(),
            },
          });
        }
      } catch { /* network error — ignore */ }
    };

    check();

    const onVisible = () => {
      if (document.visibilityState === 'visible') check();
    };
    document.addEventListener('visibilitychange', onVisible);

    const interval = setInterval(check, SIX_HOURS);

    return () => {
      document.removeEventListener('visibilitychange', onVisible);
      clearInterval(interval);
    };
  }, []);
}
